// extracted by mini-css-extract-plugin
export default {"loader":"GlobalLoader__loader--FFOiJu","hidden":"GlobalLoader__hidden--R9Xk6W"};